import { AsgardFeatureNames } from './AsgardFeatures';

export enum IMenuItemAction{
    showinburger = 'showinburger',
    hide = 'hide',
    collapse = 'collapse',
}

export interface IResponsiveBehaviour{
    width: number;
    action: IMenuItemAction;
}

export interface RootMenuItem {
    dynamic: boolean;
    feature: AsgardFeatureNames;
    expandable: boolean;
    icon?: string;
    component?: any;
    componentData?: {
        [key: string]: any
    };
    title?: string;
    click?: (...args) => void;
    children?: RootMenuItem[];
    isChild?: boolean;
    level?: number;
    image?: string;
    tooltip?: string;
    style?: IResponsiveBehaviour | null;
}
